// Currency formatter
const currencyFormat = function (n) {
  return Intl.NumberFormat(
    /(USD)|(EUR)/.test(((window.Shopify || {}).currency || {}).active || "EUR")
      ? "en-us"
      : (window.Shopify || {}).country || "en-us",
    {
      style: "currency",
      currency: ((window.Shopify || {}).currency || {}).active || "EUR",
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      minimumIntegerDigits: 1,
      useGrouping: true,
    }
  ).format(n);
};

// Recently View Functionality

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.container = null;
  }

  connectedCallback() {
    this.renderWrapper();
    this.loadProducts();
  }

  renderWrapper() {
    this.container = document.createElement('ul');
    this.container.className = 'recently_product--grid list-menu';
    this.appendChild(this.container);
  }

  loadProducts() {
    const stored = localStorage.getItem('viewedProducts');
    const handles = stored ? JSON.parse(stored) : [];
    const recentHandles = handles.slice(-5).reverse();

    for (const product of recentHandles) {
      this.fetchAndRender(product.handle);
    }
  }

  async fetchAndRender(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
      const product = await res.json();

      // Format prices
      const price = product.price / 100;
      const comparePrice = product.compare_at_price ? product.compare_at_price / 100 : null;

      let priceHTML = '';
      let savingPercent = '';

      if (comparePrice && comparePrice > price) {
        priceHTML = `
          <span class="price--compare">${currencyFormat(comparePrice)}</span>
          <span class="price--sale">${currencyFormat(price)}</span>
        `;
        // Calculate percentage discount
        savingPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
      } else {
        priceHTML = `<span class="price--sale">${currencyFormat(price)}</span>`;
      }

      const productHTML = `
        <li class="product--item item--${product.handle}">
          <div class="product-media">
              <img 
              src="${product.featured_image}" 
              alt="${product.title}" 
              loading="lazy"
              class="image"
              />
              ${savingPercent ? `<span class="saving-badge">️ ☀️ Summer Sale - Save ${savingPercent}%</span>` : ''}
          </div>
          <div class="product-info">
              <div class="product_price-wrapper">
                  ${priceHTML}
              </div>
              <h3 class="product-title">${product.title}</h3> 
              <quick-view-btn class="quick_buy--button" data-handle="${product.handle}">Quick View</quick-view-btn>
          </div>
        </li>
      `;

      this.container.insertAdjacentHTML('beforeend', productHTML);

    } catch (err) {
      console.warn(`Error rendering product: ${handle}`, err);
    }
  }
}


customElements.define('recently-viewed-products', RecentlyViewedProducts);


// Quick View Functionality

class QuickViewButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', () => this.onClick());
  }

  getOfferEndDate() {
    const datum = new Date();
    datum.setUTCHours(datum.getUTCHours() + 1);
    const wochentag = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];
    return `${wochentag[datum.getUTCDay()]}, on ${datum.getUTCDate()}.${datum.getUTCMonth() + 1}.${datum.getUTCFullYear()}`;
  }

  async onClick() {
    const handle = this.dataset.handle;
    if (!handle) {
      console.error('Product handle missing on Quick View button');
      return;
    }

    // Disable button & show spinner
    this.setAttribute('disabled', 'true');
    this.originalHTML = this.innerHTML;
    this.innerHTML = `<span class="spinner"></span> Loading...`;

    try {
      const res = await fetch(`/products/${handle}?section_id=quick-view_popup`);
      if (!res.ok) throw new Error(`HTTP Error: ${res.status}`);

      const html = await res.text();

      this.openModalWithContent(html || "⚠ No content found.");

      const deliveryUpdate = document.querySelector('.delivery-update');
      if (deliveryUpdate) {
        deliveryUpdate.textContent = `Offer ends ${this.getOfferEndDate()}`;
      }

      // Init sliders inside modal
      this.initSliders();
      this.initVariant();

      if (typeof jdgm !== 'undefined' && jdgm.renderWidgets) {
          jdgm.renderWidgets();
      }



    } catch (error) {
      console.error("Quick View load failed:", error);
      this.openModalWithContent("⚠ Failed to load product. Please try again.");
    }

    this.removeAttribute('disabled');
    this.innerHTML = this.originalHTML;
  }

  openModalWithContent(content) {
    let modal = document.querySelector('#quickViewModal');
    if (!modal) {
      modal = document.createElement('quick-view-modal');
      modal.id = 'quickViewModal';
      modal.innerHTML = `
        <div class="modal-backdrop"></div>
        <div class="modal-content">
          <button class="modal-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.306 6.5L0 1.194L1.194 0L6.5 5.306L11.806 0L13 1.194L7.694 6.5L13 11.806L11.806 13L6.5 7.694L1.194 13L0 11.806L5.306 6.5Z" fill="black"/>
            </svg>
          </button>
          <div class="modal-body">${content}</div>
        </div>
      `;
      document.body.appendChild(modal);

      // Close events
      modal.querySelector('.modal-close').addEventListener('click', () => this.closeModal());
      modal.querySelector('.modal-backdrop').addEventListener('click', () => this.closeModal());
    } else {
      modal.querySelector('.modal-body').innerHTML = content;
    }

    document.body.classList.add('no-scroll');
  }

  closeModal() {
    const modal = document.querySelector('#quickViewModal');
    if (modal) modal.remove();
    document.body.classList.remove('no-scroll');
  }

  initSliders() {
    const thumbsSwiper = new Swiper(".thumbs-swiper", {
      spaceBetween: 16,
      slidesPerView: 3,
      watchSlidesProgress: true,
    });

    const mainSwiper = new Swiper(".main-swiper", {
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      thumbs: { swiper: thumbsSwiper },
    });

    this.mainSwiper = mainSwiper;
    this.thumbsSwiper = thumbsSwiper;
  }

  initVariant() {
    const quickViewModal = document.querySelector('quick-view-modal');
    const quickViewForm = document.querySelector('[data-quickviewform]');
    const variantSelect = quickViewModal.querySelector('[name="id"]');
    const swatches = quickViewModal.querySelectorAll('.swatch');
    const productDataEl = quickViewModal.querySelector('[data-product-json]');
    const priceContainer = quickViewModal.querySelector('[data-price-container]');

    if (!variantSelect || !productDataEl || !priceContainer) return;

    const regularPriceEl = priceContainer.querySelector(".regular--price");
    const comparePriceEl = priceContainer.querySelector(".compare--price");
    let savingBadgeEl = priceContainer.querySelector(".saving-badge");

    const productData = JSON.parse(productDataEl.textContent);
    let selectedOptions = {};

    // Price update function
    const updatePrice = (variant) => {
      if (!variant) return;

      const mainPrice = variant.price / 100;
      const comparePrice = variant.compare_at_price / 100;

      // Update main price
      if (regularPriceEl) {
        regularPriceEl.textContent = currencyFormat(mainPrice);
      }

      // Show compare price & badge if applicable
      if (comparePrice && comparePrice > mainPrice) {
        const savings = ((comparePrice - mainPrice) / comparePrice) * 100;

        if (!savingBadgeEl) {
          savingBadgeEl = document.createElement("span");
          savingBadgeEl.className = "saving-badge";
          priceContainer.prepend(savingBadgeEl);
        }

        savingBadgeEl.textContent = `☀️ Summer Sale - Save ${Math.round(savings)}%`;

        if (comparePriceEl) {
          comparePriceEl.textContent = currencyFormat(comparePrice);
          comparePriceEl.style.display = "inline";
        }
      } else {
        if (savingBadgeEl) savingBadgeEl.remove();
        if (comparePriceEl) comparePriceEl.style.display = "none";
      }
    };

    // Disable unavailable swatches
    const updateSwatchAvailability = () => {
      const availableOptions = {};

      productData.variants.forEach(variant => {
        if (variant.available) {
          variant.options.forEach((opt, i) => {
            if (!availableOptions[i]) availableOptions[i] = [];
            if (!availableOptions[i].includes(opt)) {
              availableOptions[i].push(opt);
            }
          });
        }
      });

      swatches.forEach(swatch => {
        const optionName = swatch.closest(".variant-option").className.match(/option--([a-z0-9\-]+)/i)[1];
        const optionIndex = productData.options.findIndex(o => o.toLowerCase().replace(/\s+/g, '-') === optionName);

        if (!availableOptions[optionIndex] || !availableOptions[optionIndex].includes(swatch.value)) {
          swatch.disabled = true;
          swatch.classList.add("disabled");
        } else {
          swatch.disabled = false;
          swatch.classList.remove("disabled");
        }
      });
    };

    // Highlight active swatch
    const selectSwatch = (optionIndex, value) => {
      const group = quickViewModal.querySelectorAll(`.option--${productData.options[optionIndex].toLowerCase().replace(/\s+/g, '-') } .swatch`);
      group.forEach(swatch => {
        swatch.classList.toggle("active", swatch.value === value);
      });
      selectedOptions[optionIndex] = value;
    };

    // Find matching variant
    const getMatchingVariant = () => {
      return productData.variants.find(v => v.options.every((opt, i) => selectedOptions[i] === opt));
    };

    // Sync dropdown with swatches
    const syncSelectWithSwatches = () => {
      const variant = getMatchingVariant();
      if (variant) {
        variantSelect.value = variant.id;
        updatePrice(variant);
        variantSelect.dispatchEvent(new Event('change'));
      }
    };

    // Sync swatches with dropdown
    const syncSwatchesWithSelect = () => {
      const selectedVariantId = parseInt(variantSelect.value, 10);
      const variant = productData.variants.find(v => v.id === selectedVariantId);
      if (variant) {
        variant.options.forEach((opt, i) => selectSwatch(i, opt));
        selectedOptions = { ...variant.options };
        updatePrice(variant);
        updateSwatchAvailability();
      }
    };

    // Event: Swatch click
    swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const optionName = swatch.closest(".variant-option").className.match(/option--([a-z0-9\-]+)/i)[1];
        const optionIndex = productData.options.findIndex(o => o.toLowerCase().replace(/\s+/g, '-') === optionName);
        selectSwatch(optionIndex, swatch.value);
        syncSelectWithSwatches();
        updateSwatchAvailability();
      });
    });

    // Event: Select change
    variantSelect.addEventListener('change', () => {
      syncSwatchesWithSelect();

      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const targetMediaId = selectedOption.dataset.image;

      if (targetMediaId) {
        const slides = quickViewModal.querySelectorAll('.main-swiper .swiper-slide');
        const targetIndex = Array.from(slides).findIndex(slide =>
          slide.getAttribute('data-media-id') === targetMediaId
        );
        if (targetIndex !== -1) {
          this.mainSwiper.slideTo(targetIndex);
          this.thumbsSwiper.slideTo(targetIndex);
        }
      }
    });

    quickViewForm.addEventListener("submit", function (e) {
      e.preventDefault();
      // e.stopPropagation();

      let formData = new FormData(quickViewForm);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // console.log('Added to cart:', data);
          window.location.href = "/cart";
          quickViewModal.remove();
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
    });

    // Init
    syncSwatchesWithSelect();
  }

}

customElements.define('quick-view-btn', QuickViewButton);



